import React from "react";
import { RFHAutocomplete } from "../../../../../components/RFH/RFHautocomplete";

const UserSelect = ({ isColabrotar, newBoardUser, updatedUserOptions }) => {
  return (
    <RFHAutocomplete
      name="user_id"
      options={isColabrotar ? newBoardUser : updatedUserOptions}
    />
  );
};

export default UserSelect;
